import React from 'react'
import './ErrorPage.css'
import { Link } from 'react-router-dom'


export default ({ statusCode }) => (
  <div id="error-page">
    <div className="error-page">
      <div className="background-image" />
      <h1>{statusCode}</h1>
      <h2>
        {statusCode === 404 && 'Cette page n\'existe pas'}
        {statusCode > 404 && 'Une erreur est survenue'}
      </h2>
      <p>
        {statusCode === 404 && 'Désolé mais la page que vous recherchez n\'existe pas, a été supprimé ou modifié'}
        {statusCode > 404 && 'Revenez dans quelques instants, notre équipe tente de régler le problème'}
      </p>
      <div className="button-wrapper">
        <Link
          to="/"
        >
          {statusCode === 404 && 'Retour'}
          {statusCode > 404 && 'Ré-essayer'}
        </Link>
      </div>
    </div>
  </div>
)
